import { Expose } from "class-transformer";
import { IsBoolean, IsString } from "class-validator";

export class DetailsDocumentToCancel {
  @IsBoolean()
  @Expose()
  isCorrection!: boolean;

  @IsBoolean()
  @Expose()
  hasBooking!: boolean;

  @IsString()
  @Expose()
  documentNumber!: string;
}
